var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('custom-tooltip',{attrs:{"content":`Turn ${ _vm.notificationEnabled ? 'off' : 'on' } alerts`}},[_c('div',{class:['alerts', { notificationEnabled: _vm.notificationEnabled }],attrs:{"slot":"buttonContent"},slot:"buttonContent"},[_c('img',{attrs:{"src":_vm.notificationIcon,"alt":""}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }